<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'
import { Podcast, PodcastCategory } from '@/api'

export default {
  extends: BaseWidgetForm,
  created() {
    this.fixArrayFields()
    this.fetchCategories()
    this.fetchPodcasts()
  },
  data() {
    return {
      arrayFields: [],
      categoryOptions: [],
      podcastOptions: []
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Select({
              label: 'Kategoria',
              modelPath: [this, 'form', 'category'],
              options: this.categoryOptions,
              required: true
            }),
            new fields.Select({
              label: 'Najnowszy odcinek',
              modelPath: [this, 'form', 'latest_episode'],
              options: this.podcastOptions,
              required: true
            }),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              required: true
            }),
            new fields.Input({
              label: 'Prowadzący',
              modelPath: [this, 'form', 'host'],
              multilingual: false,
              required: true
            }),
            new fields.Input({
              label: 'O podcascie',
              modelPath: [this, 'form', 'about'],
              multilingual: true,
              required: false
            }),
            new fields.Input({
              label: 'Link do Youtube',
              modelPath: [this, 'form', 'youtube_url'],
              required: true
            }),
            new fields.Input({
              label: 'Link do Spotify',
              modelPath: [this, 'form', 'spotify_url'],
              required: true
            })
          ]
        }
      ]
    }
  },
  methods: {
    fetchCategories() {
      const params = { page_size: 'max' }
      PodcastCategory.fetch({}, { params }).then(res => {
        this.categoryOptions = res.data.results.map(item => {
          return { label: item.title_pl, value: item.id }
        })
      })
    },
    fetchPodcasts() {
      const params = { page_size: 'max' }
      Podcast.fetch({}, { params }).then(res => {
        this.podcastOptions = res.data.results.map(item => {
          return { label: item.title_pl, value: item.id }
        })
      })
    }
  }
}
</script>
